import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  OverlayTrigger,
  Popover
} from "react-bootstrap";
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { hasPermission } from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { adminLabels } from '../../../redux/constant/admin-label-constant';
import OpenModalButton from '../../ThemeComponents/openModelButton';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import { withRouter } from 'react-router-dom';
import ListForm from './ListForm';
import { listActions } from '../../../redux/actions/list-actions';
import { listTypeActions } from 'redux/actions/list-type-actions';

var Modal = require('react-bootstrap-modal');

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addModal: false,
      editModal: false,
      sorted: '',
      filtered: '',
      pageSize: 10,
      list: {},
      listData: [],
      parent_id: '',
      parent_data: [],
      // list_id: '',
      list_name: this.props.match.params.compName,
    };
    this.callEditlist = this.callEditlist.bind(this);
    this.deleteListItem = this.deleteListItem.bind(this);
    this.deleteConfirmListItem = this.deleteConfirmListItem.bind(this);
    this.filterSearchHandle = this.filterSearchHandle.bind(this);
    this.handleListSubmit = this.handleListSubmit.bind(this);
  };
  handleListSubmit(listData, formType) {
    if (this.state.parent_id) {
      this.setState({
        list: {
          ...this.state.list,
          title: listData.title,
          list_type_id: this.state.list_id,
          list_type: this.state.list_name,
          component_name: this.state.list_name,
          parent: listData.parent,
          parent_id: listData.parent_id,
        }
      }, () => {
        if (formType === 'add') {
          this.props.storeListCall(this.state.list).then(
            response => {
              this.props.getListCall(this.state.list_name, this.props.current_page, '', '', this.state.pageSize, 'listData', true);
              this.setState({
                ...this.state,
                addModal: false,
              })
            }
          )
        }
        else if (formType === 'edit') {
          this.props.editListCall(this.state.list, listData.id).then(response => {
            this.props.getListCall(this.state.list_name, this.props.current_page, '', '', this.state.pageSize, 'listData', true);
            this.setState({
              editModal: false
            })
          });
        }
      });
    }
    else {
      this.setState({
        list: {
          ...this.state.list,
          title: listData.title,
          list_type_id: this.state.list_id,
          list_type: this.state.list_name,
          component_name: this.state.list_name,
        }
      }, () => {
        if (formType === 'add') {
          this.props.storeListCall(this.state.list).then(
            response => {
              this.props.getListCall(this.state.list_name, this.props.current_page, '', '', this.state.pageSize, 'listData', true);
              this.setState({
                ...this.state,
                addModal: false,
              })
            },
            error => {
              return error;
            }
          )
        }
        else if (formType === 'edit') {
          this.props.editListCall(this.state.list, listData.id).then(response => {
            this.props.getListCall(this.state.list_name, this.props.current_page, '', '', this.state.pageSize, 'listData', true);
            this.setState({
              editModal: false
            })
          });
        }
      });
    }

  }

  filterSearchHandle(e) {
      this.setState({
          'filtered': e.target.value
      }, () => {
          this.refReactTable.fireFetchData()
      });
  }
  callEditlist(id) {
    this.props.getListItemCall(id).then(response => {
      this.setState({
        editModal: true
      });
    });
  }

  deleteListItem(list_id) {
    this.props.deleteListCall(list_id).then(response => {
      this.props.getListCall(this.state.list_name, this.props.current_page, this.state.filtered, '', this.state.pageSize, 'listData', true);
    });
  }
  //
  deleteConfirmListItem = (list_id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Confirmalertfordelete typeName={this.props.name} typeName={this.state.list_name}  onClosePro={onClose} deleteType={() => this.deleteListItem(list_id)} />
        )
      }
    })
  }
  // [action.payload.result.component_name]
  listingPaginationData = (page, filter, sort, pageSize) => {
    this.setState({ pageSize: pageSize }, function () {
      this.props.getListCall(this.state.list_name, page, filter, sort, pageSize, 'listData', true).then(res => {
        this.setState({
          parent_id: res.list_type.parent_id,
          parent_data: [],
          list_id: res.list_type.id,
        })
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listData !== this.props.listData) {
      this.setState({
        listData: this.props.listData
      })
    }

    if (prevProps.parentData !== this.props.parentData && this.state.list_name === 'region') {
      this.setState(
        {
          parent_data: this.props.parentData.list_type.listing,
        }
      )
    }
  }

  render() {
    const { filtered, } = this.state;
    const { pages, loading, } = this.props;
    const columns = [
      {
        Header: <div className='text-capitalize'>{this.state.list_name} List</div>,
        headerClassName: 'headerPagination',
        columns: [
          {
            Header: <div className='text-capitalize'>{this.state.list_name}</div>,
            accessor: "title",
            className: "action-center text-capitalize"
          },
          {
            Header: 'Country',
            accessor: 'parent',
            className: "action-center text-capitalize",
            show: this.state.parent_id ? true : false,
            Cell: ({ value, original }) => (
              <div>
                {
                  original.list_parent ? original.list_parent.title : ''
                }
              </div>
            )
          },
          {
            Header: "Actions",
            accessor: "id",
            Cell: ({ value, original }) => (
              <div>
                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('list-update') ? `Edit ${this.state.list_name}` : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                      hasPermission('list-update') && original.editable == 1 &&
                      <button type='button' className="editIcon orderDetailsAction " onClick={() => this.callEditlist(value)}>&nbsp;</button>

                    }
                    {
                      hasPermission('list-update') && original.editable == 0 &&
                      <button type='button' className="editIcon orderDetailsAction button_disabled" >&nbsp;</button>
                    }
                  </span>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('list-delete') ? `Delete ${this.state.list_name}` : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                      hasPermission('list-delete') && original.editable == 1 &&
                      <button type='button' className="deleteIcon orderDetailsAction" onClick={() => this.deleteConfirmListItem(value)}>&nbsp;</button>
                    }
                    {
                      hasPermission('list-delete') && original.editable == 0 &&
                      <button type='button' className="deleteIcon orderDetailsAction button_disabled" >&nbsp;</button>
                    }
                  </span>
                </OverlayTrigger>
              </div>
            ),
            className: "action-center",
            sortable: false
          }
        ]
      }
    ];

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableResponsive
                content={
                  <div>
                    <Grid fluid>
                      <Row>
                        <Col md={12}>
                          <h3 style={{ textAlign: 'center', fontWeight: "500", textTransform: "capitalize" }}>{this.state.list_name} List</h3>
                        </Col>

                        <Col md={12}>
                          <div className="flexElem mt-xlg flexResponsive" style={{ "alignItems": "flex-start", "justifyContent": "space-between" }}>
                            <div className="block">
                              <OpenModalButton
                                openModal={hasPermission('list-create') ? HF.openModal.bind(this, "addModal") : null}
                                classButton={['customBtn btnBlue', !hasPermission('list-create') ? 'button_disabled' : '']}
                                buttonName={'Add ' + [this.state.list_name]}
                                tooltipText={hasPermission('list-create') ? `Add ${this.state.list_name}` : adminLabels.DONT_ALLOW}
                                classIcon={['']}
                              />
                            </div>

                            <div className="custom-search-input">
                              <FormInputs
                                ncols={["col-md-12"]}
                                onChange={this.filterSearchHandle}
                                proprieties={[
                                  {
                                    type: "text",
                                    bsClass: "form-control",
                                    placeholder: "Search List",
                                    onChange: this.filterSearchHandle,
                                    name: "filter"
                                  }
                                ]}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col md={12} className="mt-xlg">
                          <ReactTable
                            noDataText='No data found'
                            data={this.state.listData}
                            pages={pages}
                            loading={loading}
                            columns={columns}
                            defaultPageSize={10}
                            className="-striped listing responsive"
                            pageData={this.listingPaginationData}
                            ref={(refReactTable) => {this.refReactTable = refReactTable;}}
                            manual
                            onFetchData={(state, instance) => {
                                var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                            }}
                          />
                        </Col>
                      </Row>
                    </Grid>

                    {/*Add Country Modal Start*/}
                    {this.props.listData &&
                      <Modal show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader"
                        onEnter={() => {
                          if (this.state.parent_id) {
                            this.props.getParentData(this.state.parent_id);
                          }
                        }}
                        backdrop={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title id='ModalHeader' className="headerTitle text-capitalize">Add {this.state.list_name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                              <ListForm
                                closeModel={HF.closeModal.bind(this, "addModal")}
                                formTypePro="add"
                                listPro={{ list: OC.list }}
                                handleListSubmit={this.handleListSubmit}
                                name={this.props.title}
                                componentPro={'List'}
                                parentData={this.props.listItempParent}
                                parent_id={this.state.parent_id}
                              />
                            </div>
                          </div>
                        </Modal.Body>
                      </Modal>
                    }
                    {/*Add Country Modal End*/}

                    {/*Edit Country Modal start*/}
                    {this.props.listItem &&
                      <Modal show={this.state.editModal} onHide={HF.closeModal.bind(this, "editModal")} aria-labelledby="ModalHeader"
                        onEnter={() => {
                          if (this.state.parent_id) {
                            this.props.getParentData(this.state.parent_id);
                          }
                        }}
                        backdrop={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title id='ModalHeader' className="headerTitle text-capitalize">Edit {this.state.list_name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                              <ListForm
                                closeModel={HF.closeModal.bind(this, "editModal")}
                                formTypePro="edit"
                                listPro={this.props.listItem}
                                handleListSubmit={this.handleListSubmit}
                                name={this.props.title}
                                parentData={this.props.listItempParent}
                                parent_id={this.state.parent_id}
                              />
                            </div>
                          </div>
                        </Modal.Body>
                      </Modal>
                    }
                    {/*Edit Country Modal End*/}
                  </div>
                } />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  };
}

const mapDispatchToProps = dispatch => {
  return ({
    getAllListTypesCall: () => { dispatch(listActions.getAllListTypes()) },
    getListCall: (list_name, page, filter, sort, pageSize, component_name, pagination) => { return dispatch(listActions.getList(list_name, page, filter, sort, pageSize, component_name, pagination)) },
    getListItemCall: (id) => { return dispatch(listActions.getListItem(id)) },
    storeListCall: (listData) => { return dispatch(listActions.storeList(listData)) },
    editListCall: (listData, id) => { return dispatch(listActions.editList(listData, id)) },
    deleteListCall: (id) => { return dispatch(listActions.deleteList(id)) },
    getParentData: (parentId) => { dispatch(listTypeActions.getParentData(parentId)) },
  });
};

function mapStateToProps(state, ownProps) {

  // const data = [`${[ownProps.name]}`];
  const { list_types, listData, loading, pages, current_page, listItem, listItempParent, list_type_name
  } = state.listReducer;

  return {
    parentData: state.listReducer[ownProps.parent],
    loading, pages, current_page,
    listItem,
    listData,
    list_types,
    listItempParent,
    list_type_name
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/components/Admin/Lists/List.jsx